import React from 'react';
import { cn } from '@/lib/utils';
import Icon, { IconComponent } from './Icon';

type StatTone = 'brand' | 'warning' | 'info';

const tones: Record<StatTone, string> = {
  brand: 'tw-bg-ds-brand-tint tw-text-ds-brand-text',
  warning: 'tw-bg-ds-warning-bg tw-text-ds-warning-fg',
  info: 'tw-bg-ds-info-bg tw-text-ds-info-fg',
};

interface StatCardProps {
  icon: IconComponent;
  tone: StatTone;
  value: React.ReactNode;
  label: string;
  className?: string;
}

/** Summary count. Compact on mobile (three across), default size from tablet up. */
const StatCard: React.FC<StatCardProps> = ({ icon, tone, value, label, className }) => (
  <div
    className={cn(
      'tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-items-start tw-gap-2 tw-rounded-2xl tw-border tw-border-ds-border-default tw-bg-ds-surface tw-p-[13px] md:tw-gap-3 md:tw-p-[18px]',
      className,
    )}
  >
    <span className={cn('tw-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-lg md:tw-h-9 md:tw-w-9 md:tw-rounded-[10px]', tones[tone])}>
      <Icon icon={icon} size={16} className="md:tw-hidden" />
      <Icon icon={icon} size={18} className="tw-hidden md:tw-block" />
    </span>
    <p className="tw-text-[22px] tw-font-bold tw-leading-7 tw-text-ds-text-primary md:tw-text-[28px] md:tw-leading-[34px]">{value}</p>
    <p className="tw-w-full tw-text-[12px] tw-font-medium tw-leading-4 tw-text-ds-text-secondary md:tw-text-[13px] md:tw-leading-[18px]">{label}</p>
  </div>
);

export default StatCard;
